import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalCampaignOrderDataStatisticsModel, LocalCampaignMediaStatisticsFilters, LocalCampaignOrderDataStatisticsTimechartModel, RenaultLocalCampaignOrderDTO, RenaultLocalCampaignOrderListFilterDTO, RenaultLocalCampaignOrderSendTestDTO, RenaultLocalCampaignOrderStatisticsDTO, LocalCampaignEmailStatisticsTable, LocalCampaignEmailStatisticsModel, LocalCampaignSmsStatisticsModel, LocalCampaignSmsStatisticsTable, LocalCampaignSmsCostModel } from '../models/renault-local-campaign-order-dto';
import { Select2Data } from 'ng-select2-component';
import { DataTablesResponse } from '../models/datatables';
import { LocalCampaignStatisticsKpiTotalModel } from '../models/renault-kpi-dto';

@Injectable({
  providedIn: 'root'
})

export class LocalCampaignOrderService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultLocalCampaignOrder/";
  filterResult: RenaultLocalCampaignOrderListFilterDTO = new RenaultLocalCampaignOrderListFilterDTO();

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<RenaultLocalCampaignOrderDTO> {
    return this.http.get<RenaultLocalCampaignOrderDTO>(this.pathAPI + this.controller + id);
  }

  public initializeOrder(data: RenaultLocalCampaignOrderDTO): Observable<RenaultLocalCampaignOrderDTO> {
    return this.http.post<RenaultLocalCampaignOrderDTO>(this.pathAPI + this.controller + "InitializeOrder", data);
  }

  public put(id: string, data: RenaultLocalCampaignOrderDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public updateBBDD(id: string, data: FormData): Observable<any> {
    let requestOptions: Object = {
      responseType: 'string'
    }
    return this.http.put<any>(this.pathAPI + this.controller + "UpdateBBDD/" + id, data, requestOptions);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public changeDesiredDate(id: string, date: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeDesiredDate/' + id + '/' + date, null);
  }

  public sendTest(data: RenaultLocalCampaignOrderSendTestDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "SendTest", data);
  }

  public getDefaultValues(idDistri: string[], idBrand: number): Observable<any[]> {
    return this.http.post<any[]>(this.pathAPI + this.controller + "GetDefaultValues/" + idBrand, idDistri);
  }

  public getCampaignOrderListCampaign(idCampaignMedia: number, idBrand: number): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaignOrderListCampaign/' + idCampaignMedia + '/' + idBrand);
  }

  public getCampaignOrderList(data: RenaultLocalCampaignOrderListFilterDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "GetCampaignOrderList", data);
  }

  public getCampaignOrderDetailStatistics(idOrder: string): Observable<RenaultLocalCampaignOrderStatisticsDTO> {
    return this.http.get<RenaultLocalCampaignOrderStatisticsDTO>(this.pathAPI + this.controller + 'GetCampaignOrderDetailStatistics/' + idOrder);
  }

  public getLocalCampaignOrderStatistics(idOrders: number[]): Observable<LocalCampaignOrderDataStatisticsModel> {
    return this.http.post<LocalCampaignOrderDataStatisticsModel>(this.pathAPI + this.controller + 'GetLocalCampaignOrderStatistics/', idOrders);
  }

  public GetLocalCampaignEmailStatistics(filters: LocalCampaignMediaStatisticsFilters): Observable<LocalCampaignEmailStatisticsModel> {
    return this.http.post<LocalCampaignEmailStatisticsModel>(this.pathAPI + this.controller + 'GetLocalCampaignEmailStatistics/', filters);
  }

  public GetLocalCampaignEmailStatisticsTable(filters: LocalCampaignMediaStatisticsFilters): Observable<LocalCampaignEmailStatisticsTable[]> {
    return this.http.post<LocalCampaignEmailStatisticsTable[]>(this.pathAPI + this.controller + 'GetLocalCampaignEmailStatisticsTable/', filters);
  }

  downloadExcelLocalCampaignEmailStatistics(filters: LocalCampaignMediaStatisticsFilters): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignEmailStatisticsExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }


  public GetLocalCampaignSmsStatistics(filters: LocalCampaignMediaStatisticsFilters): Observable<LocalCampaignSmsStatisticsModel> {
    return this.http.post<LocalCampaignSmsStatisticsModel>(this.pathAPI + this.controller + 'GetLocalCampaignSmsStatistics/', filters);
  }

  public GetLocalCampaignSmsStatisticsTable(filters: LocalCampaignMediaStatisticsFilters): Observable<LocalCampaignSmsStatisticsTable[]> {
    return this.http.post<LocalCampaignSmsStatisticsTable[]>(this.pathAPI + this.controller + 'GetLocalCampaignSmsStatisticsTable/', filters);
  }

  downloadExcelLocalCampaignSmsStatistics(filters: LocalCampaignMediaStatisticsFilters): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignSmsStatisticsExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  public GetLocalCampaignSmsCost(filters: LocalCampaignMediaStatisticsFilters): Observable<LocalCampaignSmsCostModel[]> {
    return this.http.post<LocalCampaignSmsCostModel[]>(this.pathAPI + this.controller + 'GetLocalCampaignSmsCost/', filters);
  }



  public getLocalCampaignOrderStatisticsTimechart(idOrders: number[]): Observable<LocalCampaignOrderDataStatisticsTimechartModel[]> {
    return this.http.post<LocalCampaignOrderDataStatisticsTimechartModel[]>(this.pathAPI + this.controller + 'GetLocalCampaignOrderStatisticsTimechart/', idOrders);
  }

  getLocalCampaignOrderDataStatisticsExcelMail(idOrder: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignOrderDataStatisticsExcelMail/' + idOrder;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  getLocalCampaignOrderDataStatisticsExcelSms(idOrder: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignOrderDataStatisticsExcelSms/' + idOrder;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  public GetLocalCampaignEmailStatisticsSelectCampaign(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetLocalCampaignEmailStatisticsSelectCampaign');
  }

  public GetLocalCampaignSmsStatisticsSelectCampaign(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetLocalCampaignSmsStatisticsSelectCampaign');
  }


  downloadExcelLocalCampaignEmailOrderStatistics(filters: RenaultLocalCampaignOrderListFilterDTO): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignEmailOrderStatisticsExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  downloadExcelLocalCampaignSmsOrderStatistics(filters: RenaultLocalCampaignOrderListFilterDTO): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignSmsOrderStatisticsExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }


  public SetOderDistributors(idOrder: string, distributors: string[]): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "SetOderDistributors/" + idOrder, distributors);
  }

  public GetOderDistributors(idOrder: string): Observable<number[]> {
    return this.http.get<number[]>(this.pathAPI + this.controller + "GetOderDistributors/" + idOrder);
  }

  public SendMailNewOrderDistributor(idOrder: string,): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "SendMailNewOrderDistributor/" + idOrder, null);
  }

  public getPendingOrderValidationIds(): Observable<number[]> {
    return this.http.get<number[]>(this.pathAPI + this.controller + 'GetPendingOrderValidationIds');
  }

  public getDatatableOrderValidation(data: any, filter): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDatatableOrderValidation/' + filter, data);
  }

  public changeStatusOrderValidation(id: string, idStatus: number, declinedReason: string = null): Observable<any> {

    if (declinedReason)
      return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatusOrderValidation/' + id + '/' + idStatus + '?declinedReason=' + declinedReason, null);
    else
      return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatusOrderValidation/' + id + '/' + idStatus, null);
  }

  public GetOrderContactCount(id: string): Observable<number> {
    return this.http.get<number>(this.pathAPI + this.controller + 'GetOrderContactCount/' + id);
  }

  public GetOrderSentCount(id: string): Observable<number> {
    return this.http.get<number>(this.pathAPI + this.controller + 'GetOrderSentCount/' + id);
  }

  public GetOrderProcessCount(id: string): Observable<number> {
    return this.http.get<number>(this.pathAPI + this.controller + 'GetOrderProcessCount/' + id);
  }

  public getLocalCampaignStatisticsForKpi(years: number[]): Observable<LocalCampaignStatisticsKpiTotalModel[]> {
    return this.http.post<LocalCampaignStatisticsKpiTotalModel[]>(this.pathAPI + this.controller + 'GetLocalCampaignStatisticsKpi', years);
  }

  public ResetInProcessOrder(idOrder: string): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "ResetInProcessOrder/" + idOrder, null);
  }

  setFilter(filter: RenaultLocalCampaignOrderListFilterDTO) {

    this.filterResult = filter;

  }

  getFilter() {

    return this.filterResult;

  }

  removeFilter() {

    this.filterResult = new RenaultLocalCampaignOrderListFilterDTO();

  }
}
